import { TextArea } from "@blueprintjs/core";
import React from "react";
import { FormItemBuilderProperties } from "../Form";

export const TextBuilder = (bundle: FormItemBuilderProperties<any>) => (
  <TextArea
    id={bundle.field_index}
    large
    style={{ width: "100%" }}
    // leftIcon={bundle.prop.icon}
    disabled={bundle.form_state.submitting || bundle.field_properties.readonly}
    placeholder={bundle.field_properties.placeholder}
    value={bundle.form_state.values[bundle.field_index] || ""}
    onChange={({ currentTarget }: React.FormEvent<HTMLTextAreaElement>) =>
      bundle.update_value(currentTarget.value)
    }
  />
);
